import { createSlice } from "@reduxjs/toolkit";

const gstSlice = createSlice({
    name: 'gst',
    initialState: {
        gst: []
    },
    reducers: {
        addGst: (state, action) => {
            state.gst = [...state.gst, action.payload]
        },
        // removeOccupation(){
        //     return state.occupation.filter((item)=> item.id != action.payload);
        // }
    }
});

export const { addGst } = gstSlice.actions;
export default gstSlice.reducer;